import React, { Fragment, ChangeEvent, FC, useState, useEffect } from "react";
import "../../../styles/task.scss";
import { useNavigate } from "react-router-dom";
import {
  ErrorMessage,
  Field,
  FieldArray,
  Form,
  Formik,
  FormikHelpers,
} from "formik";
import { isAuth } from "../../auth/ProtectedRoute";
import { ProjectCoverImage, ProjectValues } from "./Types/DataType";
import * as Yup from "yup";
import axios from "axios";
import swal from "sweetalert";
import { ActivityLogValues } from "../ActivityLog/types/DataType";
import {
  Autocomplete,
  Chip,
  CircularProgress,
  AutocompleteRenderGetTagProps,
  TextField,
  NativeSelect,
} from "@mui/material";
import ReactFlagsSelect from "react-flags-select";

const AddProject: FC = () => {
  const navigate = useNavigate();
  const [mediaLoading, setMediaLoading] = useState<boolean>(false);
  const [mediaBinary, setMediaBinary] = useState<ReturnType<any>>([]);
  const [countri, setCountri] = useState<[]>([]);
  const [selectedCount, setSelectedCount] = useState("");

  //formik form initial values
  const initialValues: ProjectValues = {
    title: "",
    email: "",
    fullname: "",
    keywords: [],
    type: "",
    sub_category: null,
    experience: "",
    description: "",
    bid: "",
    bid_response_timeline: "",
    preferred_location: "",
    has_budget: "1",
    budget: 10,
    min_budget: 10,
    max_budget: 11,
    duration: "",
    cover_image: {} as ProjectCoverImage,
    attachments: [],
    skills: [],
    faqs: [],
  };

  let countries = "";
  const str: [""] = [""];

  useEffect(() => {
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `manage-locations/location`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        if (res.data.response === true) {
          // console.log(res.data.data);
          setCountri(res.data.data);
          res.data.data.map((count: any) => {
            str.push(count.code);
          });
          str.splice(0, 1);
          countries = str.join(",");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getAttachFilename = (mediaString: any) => {
    const ext = mediaString?.split(".").pop();
    const tag = mediaString?.slice(0, 11);
    return `${tag}.${ext}`;
  };

  const getCurrentDate = () => {
    const d = new Date();
    const day = d.getDate();
    const month = d.toLocaleString("default", { month: "short" });
    const year = d.getFullYear();
    const date = `${month} ${day}, ${year}`;
    return date;
  };

  return (
    <Fragment>
      <div className="project-add">
        <div className="project-add-wrapper">
          <div className="project-add--heading">
            <div className="project-add--heading--title">
              <h1>Add Project</h1>
            </div>
            <div className="project-add--heading-btn">
              <button onClick={() => navigate(-1)}>
                <span>
                  <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 2L2 7L7 12"
                      stroke="white"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2 7H10C15.523 7 20 11.477 20 17V18"
                      stroke="white"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                Back
              </button>
            </div>
          </div>
        </div>
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            title: Yup.string()
              .min(5, "Title must have at least 5 Characters")
              .max(60, "Title cannot be more than 60 Characters")
              .required("This field is required"),
            email: Yup.string()
              .email("Invalid email address")
              .required("This field is required"),
            fullname: Yup.string().required("This field is required"),
            keywords: Yup.array()
              .of(
                Yup.string().min(
                  3,
                  "Each keyword cannot be less than 3 characters"
                )
              )
              .min(1, "This field is required")
              .max(5, "You can only add 5 keywords!"),
            type: Yup.string().required("This field is required"),
            sub_category: Yup.number()
              .typeError("This field is required")
              .required("This field is required"),
            experience: Yup.string().required("This field is required"),
            description: Yup.string()
              .required("This field is required")
              .min(5, "Description must have at least 5 characters")
              .max(1000, "Description cannot be more than 1000 characters"),
            bid: Yup.string().required("This field is required"),
            bid_response_timeline: Yup.date()
              .min(
                new Date(Date.now()),
                "Response Timeline cannot be older than today"
              )
              .required("This field is required"),
            preferred_location: Yup.string().required("This field is required"),
            budget: Yup.number()
              .typeError("This field is required")
              .min(10, "Budget cannot be less than 10")
              .required("This field is required"),
            min_budget: Yup.number()
              .typeError("This field is required")
              .min(10, "Minimum Budget cannot be less than 10")
              .required("This field is required"),
            max_budget: Yup.number()
              .typeError("This field is required")
              .min(11, "Maximum Budget cannot be less than 10")
              .required("This field is required"),
            duration: Yup.string().required("This field is required"),
            cover_image: Yup.object().required("This field is required"),
            attachments: Yup.array()
              .min(1, "This field is required")
              .max(5, "This field is required"),
            skills: Yup.array()
              .of(
                Yup.string().min(
                  3,
                  "Each skill cannot be less than 3 characters"
                )
              )
              .min(1, "This field is required")
              .max(5, "You can only add 5 Skills!"),
            faqs: Yup.array().of(
              Yup.object().shape({
                question: Yup.string().required("This field is required"),
                answer: Yup.string().required("This field is required"),
              })
            ),
          })}
          onSubmit={(
            values: ProjectValues,
            { setSubmitting }: FormikHelpers<ProjectValues>
          ) => {
            //payload for feed values
            const formdata = new FormData();
            formdata.append("email", values.email);
            formdata.append("fullname", values.fullname);
            formdata.append("title", values.title);
            values.keywords.forEach((key, index) => {
              formdata.append(`keyword[${index}]`, key);
            });
            formdata.append("sub_category", values.sub_category);
            formdata.append("cover_image", values.cover_image.filepath);
            formdata.append("experience", values.experience);
            values.skills.forEach((skill, index) => {
              formdata.append(`skill[${index}]`, skill);
            });
            formdata.append("type", values.type);
            formdata.append("bid", values.bid);
            formdata.append(
              "bid_response_timeline",
              values.bid_response_timeline
            );
            formdata.append("preferred_location", values.preferred_location);
            formdata.append("has_budget", values.has_budget);
            if (values.has_budget === "1") {
              formdata.append("budget", values.budget?.toString());
            } else {
              formdata.append("budget", values.budget?.toString());
              formdata.append("min_budget", values.min_budget?.toString());
              formdata.append("max_budget", values.max_budget?.toString());
            }
            formdata.append("duration", values.bid_response_timeline); //duration replaced with bid_response_timeline for validation
            formdata.append("description", values.description);
            values.faqs.forEach((faq, index) => {
              formdata.append(`question[${index}]`, faq.question);
              formdata.append(`answer[${index}]`, faq.answer);
            });
            mediaBinary.forEach((attach: any, index: number) => {
              formdata.append(`attachment[${index}]`, attach.filepath);
              formdata.append(
                `original_filename[${index}]`,
                attach.original_name
              );
            });
            formdata.append("show_question", "1");
            //request to submit feed data to server
            axios({
              method: "POST",
              url: process.env.REACT_APP_HOST_API + `project`,
              headers: {
                Authorization: `Bearer ${isAuth()}`,
              },
              data: formdata,
            })
              .then((res) => {
                setSubmitting(false);
                if (res.data.response === true) {
                  //activity log request submitted to server
                  let activityLogItem;
                  if (typeof window !== "undefined") {
                    if (sessionStorage.getItem("activityDetail")) {
                      activityLogItem = JSON.parse(
                        sessionStorage.getItem("activityDetail")!
                      );
                    }
                  }
                  const activityDetail: ActivityLogValues = {
                    full_name: activityLogItem.full_name,
                    role: activityLogItem.role,
                    ip_address: activityLogItem.ip_address,
                    browser: activityLogItem.browser,
                    events: `Added Project`,
                    module: "Task Management",
                    location: activityLogItem.location,
                    email: activityLogItem.email,
                  };
                  axios({
                    method: "POST",
                    url:
                      process.env.REACT_APP_HOST_API + "manage-activity/user",
                    headers: {
                      Authorization: `Bearer ${isAuth()}`,
                    },
                    data: activityDetail,
                  });
                  swal({
                    title: "Success!",
                    text: "Project created successfully!",
                    icon: "success",
                  });
                  navigate(-1);
                } else if (
                  // server error 401 handling
                  res.data.response === false &&
                  res.data.status === 401
                ) {
                  swal({
                    title: "Error!",
                    text: res.data.message,
                    icon: "error",
                  });
                } else if (
                  // server error 404 handling
                  res.data.response === false &&
                  res.data.status === 404
                ) {
                  swal({
                    title: "Error!",
                    text: res.data.message,
                    icon: "error",
                  });
                } else if (
                  // server error 406 handling
                  res.data.response === false &&
                  res.data.status === 406
                ) {
                  swal({
                    title: "Error!",
                    text: res.data.message,
                    icon: "error",
                  });
                } else if (
                  // server error 409 handling
                  res.data.response === false &&
                  res.data.status === 409
                ) {
                  swal({
                    title: "Error!",
                    text: res.data.message,
                    icon: "error",
                  });
                } else if (
                  // server error 500 handling
                  res.data.response === false &&
                  res.data.status === 500
                ) {
                  swal({
                    title: "Error!",
                    text: "Something went wrong. Please try again later!",
                    icon: "error",
                  });
                }
              })
              .catch((err) => {
                console.error(err);
                swal({
                  title: "Error!",
                  text: "Something went wrong. Please try again later!",
                  icon: "error",
                });
              });
          }}
        >
          {({ values, errors, isSubmitting, setFieldValue }) => (
            <>
              <Form noValidate autoComplete="off">
                {/* <pre>{JSON.stringify({ values, errors }, null, 2)}</pre> */}
                <div className="project-add--form">
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="email">Email</label>
                      <Field
                        id="email"
                        name="email"
                        type="text"
                        placeholder="@mail.com"
                      />
                      <ErrorMessage name="email">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item">
                      <label htmlFor="fullname">fullname</label>
                      <Field
                        id="fullname"
                        name="fullname"
                        type="text"
                        placeholder="Agbo Ebuka"
                      />
                      <ErrorMessage name="fullname">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="title">Project Title</label>
                      <Field
                        id="title"
                        name="title"
                        type="text"
                        placeholder="Project Title"
                      />
                      <ErrorMessage name="title">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item">
                      <label htmlFor="keywords">Keywords</label>
                      <Autocomplete
                        multiple
                        id="keywords"
                        options={[]}
                        freeSolo
                        onChange={(event, values) => {
                          setFieldValue("keywords", values);
                        }}
                        renderTags={(
                          value: readonly string[],
                          getTagProps: AutocompleteRenderGetTagProps
                        ) =>
                          value.map((option: string, index: number) => (
                            // eslint-disable-next-line react/jsx-key
                            <Chip
                              // key={option + index}
                              variant="outlined"
                              label={option}
                              {...getTagProps({ index })}
                              // className={style.chip}
                              sx={{
                                "& .MuiChip-label": {
                                  fontFamily: "Poppins",
                                  color: "#565656",
                                  fontWeight: 500,
                                },
                                "& .MuiChip-deleteIcon": {
                                  color: "#ca8410",
                                },
                                "& .MuiChip-deleteIcon:hover": {
                                  color: "#ca8410",
                                },
                              }}
                            />
                          ))
                        }
                        renderInput={(params: any) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Press Enter to insert Keyword"
                            sx={{
                              "& .MuiAutocomplete-inputRoot": {
                                border: "0.4px solid #dfdfdf",
                                borderRadius: "5px",
                                background: "white",
                              },
                              "& .MuiAutocomplete-input": {
                                border: "none !important",
                              },
                              "& .MuiInput-input": {
                                padding: "9px 25px !important",
                              },
                              "& .MuiInput-root:before": {
                                "border-bottom": "none !important",
                              },
                              "& .MuiInput-root:after": {
                                "border-bottom": "none !important",
                              },
                            }}
                          />
                        )}
                      />
                      <ErrorMessage name="keywords">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="sub_category">
                        Category & Sub-category
                      </label>
                      <Field
                        as={NativeSelect}
                        name="sub_category"
                        id="sub_category"
                        className="nativeselect"
                      >
                        <option value="" selected hidden>
                          Select
                        </option>
                        {/* {categoryArray.map((category) => ( */}
                        <optgroup label="{category.name}">
                          {/* {category.sub_categories.map((subCategory) => ( */}
                          <option
                            // key='{subCategory.id}'
                            value={1}
                          >
                            Sucategory1
                          </option>

                          {/* ))} */}
                        </optgroup>
                        {/* ))} */}
                      </Field>
                      <ErrorMessage name="sub_category">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item">
                      <label htmlFor="cover_image">
                        <Field
                          id="cover_image"
                          name="cover_image"
                          type="file"
                          // multiple={true}
                          value={""}
                          accept="image/png, image/jpg, image/jpeg"
                          style={{ display: "none" }}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            const file = event?.currentTarget?.files![0];
                            //error handling for files larger than 5mb
                            if (file.size > 5242880) {
                              swal({
                                title: "Error!",
                                text: "Invalid file size, images cannot be larger than 5MB",
                                icon: "error",
                              });
                              return;
                            } else {
                              //media upload request to server
                              const formdata = new FormData();
                              formdata.append(`files[0]`, file);
                              formdata.append(
                                "env",
                                `${process.env.REACT_APP_ENV}`
                              );
                              setMediaLoading(true);
                              axios({
                                method: "POST",
                                url:
                                  process.env.REACT_APP_HOST_API +
                                  `uploads/file`,
                                data: formdata,
                              })
                                .then((res) => {
                                  setFieldValue(
                                    "cover_image",
                                    res?.data?.data[0]
                                  );
                                  setMediaLoading(false);
                                })
                                .then(() => {
                                  setMediaLoading(false);
                                })
                                .catch((error) => {
                                  setMediaLoading(false);
                                  console.log(error);
                                  swal({
                                    title: "Error!",
                                    text: "Something went wrong. Please try again later!",
                                    icon: "error",
                                  });
                                });
                            }
                          }}
                        />
                        <div className="cover">
                          Cover Image
                          <div className="coverImage">
                            <Field
                              name="cover_image"
                              type="text"
                              value={values.cover_image.original_name}
                            />
                            <div className="add-button">Add</div>
                          </div>
                        </div>
                      </label>
                      {mediaLoading && (
                        <CircularProgress sx={{ color: "gray" }} size={12} />
                      )}
                      <ErrorMessage name="cover_image">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="experience">Experience level</label>
                      <Field
                        as={NativeSelect}
                        name="experience"
                        id="experience"
                        className="nativeselect"
                      >
                        <option value="" selected hidden>
                          Select
                        </option>
                        <option value="Any Level">Any Level</option>
                        <option value="Entry Level">Entry Level</option>
                        <option value="Intermediate">Intermediate</option>
                        <option value="Expert">Expert</option>
                      </Field>
                      <ErrorMessage name="experience">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item">
                      <label htmlFor="skills">Required Skills</label>
                      <Autocomplete
                        multiple
                        id="skills"
                        options={[]}
                        freeSolo
                        onChange={(event, values) => {
                          setFieldValue("skills", values);
                        }}
                        renderTags={(
                          value: readonly string[],
                          getTagProps: AutocompleteRenderGetTagProps
                        ) =>
                          value.map((option: string, index: number) => (
                            // eslint-disable-next-line react/jsx-key
                            <Chip
                              // key={option + index}
                              variant="outlined"
                              label={option}
                              {...getTagProps({ index })}
                              // className={style.chip}
                              sx={{
                                "& .MuiChip-label": {
                                  fontFamily: "Poppins",
                                  color: "#565656",
                                  fontWeight: 500,
                                },
                                "& .MuiChip-deleteIcon": {
                                  color: "#ca8410",
                                },
                                "& .MuiChip-deleteIcon:hover": {
                                  color: "#ca8410",
                                },
                              }}
                            />
                          ))
                        }
                        renderInput={(params: any) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Press Enter to insert skill"
                            sx={{
                              "& .MuiAutocomplete-inputRoot": {
                                border: "0.4px solid #dfdfdf",
                                borderRadius: "5px",
                                background: "white",
                              },
                              "& .MuiAutocomplete-input": {
                                border: "none !important",
                              },
                              "& .MuiInput-input": {
                                padding: "9px 25px !important",
                              },
                              "& .MuiInput-root:before": {
                                "border-bottom": "none !important",
                              },
                              "& .MuiInput-root:after": {
                                "border-bottom": "none !important",
                              },
                            }}
                          />
                        )}
                      />
                      <ErrorMessage name="skills">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="type">Project Type</label>
                      <Field
                        as={NativeSelect}
                        name="type"
                        id="type"
                        className="nativeselect"
                      >
                        <option value="" selected hidden>
                          Select
                        </option>
                        <option value="onetime">One Time</option>
                        <option value="milestone" disabled>
                          milestone
                        </option>
                      </Field>
                      <ErrorMessage name="type">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item">
                      <label htmlFor="bid">Bid</label>
                      <Field
                        as={NativeSelect}
                        name="bid"
                        id="bid"
                        className="nativeselect"
                      >
                        <option value="" selected hidden>
                          Select
                        </option>
                        <option value={1}>Invited Users</option>
                        <option value={2}>Anyone</option>
                      </Field>
                      <ErrorMessage name="bid">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="bid_response_timeline">
                        Bid Response Timeline
                      </label>
                      <Field
                        type="date"
                        name="bid_response_timeline"
                        id="bid_response_timeline"
                      />
                      <ErrorMessage name="bid_response_timeline">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item">
                      <label htmlFor="preferred_location">
                        Preferred Location
                      </label>
                      <Field
                        component={ReactFlagsSelect}
                        id="preferred_location"
                        name="preferred_location"
                        type="text"
                        className="selectCountry"
                        selected={selectedCount}
                        countries={countries}
                        searchable={true}
                        searchPlaceholder="Search for a country"
                        onSelect={(code: any) => {
                          countri.map((count: any) => {
                            if (code === count.code) {
                              setSelectedCount(code);
                              setFieldValue("preferred_location", count.id);
                            }
                          });
                        }}
                      ></Field>
                      <ErrorMessage name="preferred_location">
                        {(msg: string) => (
                          <div style={{ color: "red" }}>{msg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="has_budget">
                        Do you have a budget for this project?
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Field
                            type="radio"
                            name="has_budget"
                            id="has_budget"
                            value="1"
                          />
                          Yes
                        </label>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Field
                            type="radio"
                            name="has_budget"
                            id="has_budget"
                            value="2"
                          />
                          No
                        </label>
                      </div>

                      <ErrorMessage name="has_budget">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item">
                      {values.has_budget === "1" ? (
                        <>
                          <label htmlFor="budget">
                            Enter your budget for this project
                          </label>
                          <Field
                            type="number"
                            name="budget"
                            id="budget"
                            placeholder="$ 10"
                            min={10}
                          />
                          <ErrorMessage name="budget">
                            {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                          </ErrorMessage>
                        </>
                      ) : (
                        <>
                          <label htmlFor="min_budget">
                            Enter your budget for this project
                          </label>
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                              fontFamily: "Poppins",
                              fontSize: "38px",
                            }}
                          >
                            <Field
                              type="number"
                              name="min_budget"
                              id="min_budget"
                              placeholder="Min"
                              min={10}
                            />
                            <ErrorMessage name="min_budget">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                            <label htmlFor="max_budget"></label>
                            {"  "}-{"  "}
                            <Field
                              type="number"
                              name="max_budget"
                              id="max_budget"
                              placeholder="Max"
                              min={11}
                            />
                            <ErrorMessage name="max_budget">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="project-add--form-row">
                    <div className="project-add--form-row--item">
                      <label htmlFor="duration">
                        Expected Project Duration
                      </label>
                      <Field
                        as={NativeSelect}
                        name="duration"
                        id="duration"
                        className="nativeselect"
                      >
                        <option value="" selected disabled hidden>
                          Select
                        </option>
                        <option value="less than 1 month">
                          Less than 1 month
                        </option>
                        <option value="1-3 months">1-3 months</option>
                        <option value="3-6 months">3-6 months</option>
                        <option value="more than 6 months">
                          More than 6 months
                        </option>
                      </Field>
                      <ErrorMessage name="duration">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="project-add--form-row--item"></div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--desc">
                      <label htmlFor="description">Project Description</label>
                      <Field
                        id="description"
                        as="textarea"
                        name="description"
                        placeholder="Please add project description..."
                      />
                      <ErrorMessage name="description">
                        {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="project-add--form-row">
                    <div className="project-add--form-row--desc">
                      <label htmlFor="faqs" id="faq-label">
                        FAQS
                      </label>
                      <FieldArray name="faqs">
                        {({ remove, push }) => (
                          <>
                            {values.faqs.map((faq, index) => {
                              return (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      width: "100%",
                                      marginTop: "25px",
                                    }}
                                  >
                                    <label htmlFor="question">
                                      Question {index + 1}
                                    </label>
                                    <div onClick={() => remove(index)}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M15.4152 3.5122C15.4152 3.70336 15.345 3.88787 15.218 4.03073C15.0909 4.17359 14.9159 4.26485 14.726 4.28722L14.6347 4.29268H13.9752L13.0144 14.0644C12.9621 14.5946 12.7145 15.0864 12.3196 15.4442C11.9248 15.8019 11.411 16.0001 10.8782 16H5.12291C4.59011 16.0001 4.07634 15.8019 3.68151 15.4442C3.28668 15.0864 3.03903 14.5946 2.98672 14.0644L2.02594 4.29268H1.36643C1.15943 4.29268 0.960907 4.21045 0.814537 4.06408C0.668167 3.91771 0.585938 3.71919 0.585938 3.5122C0.585938 3.3052 0.668167 3.10668 0.814537 2.96031C0.960907 2.81394 1.15943 2.73171 1.36643 2.73171H5.26886C5.26886 2.37297 5.33952 2.01775 5.4768 1.68633C5.61408 1.3549 5.8153 1.05376 6.06896 0.800099C6.32263 0.546436 6.62377 0.34522 6.95519 0.207939C7.28662 0.0706577 7.64184 0 8.00057 0C8.3593 0 8.71453 0.0706577 9.04595 0.207939C9.37738 0.34522 9.67852 0.546436 9.93218 0.800099C10.1858 1.05376 10.3871 1.3549 10.5243 1.68633C10.6616 2.01775 10.7323 2.37297 10.7323 2.73171H14.6347C14.8417 2.73171 15.0402 2.81394 15.1866 2.96031C15.333 3.10668 15.4152 3.3052 15.4152 3.5122ZM9.75667 6.04878C9.61522 6.04879 9.47855 6.10001 9.37194 6.19299C9.26534 6.28596 9.196 6.4144 9.17677 6.55454L9.1713 6.63415V12.0976L9.17677 12.1772C9.19604 12.3173 9.26539 12.4457 9.372 12.5386C9.4786 12.6315 9.61524 12.6827 9.75667 12.6827C9.8981 12.6827 10.0347 12.6315 10.1413 12.5386C10.2479 12.4457 10.3173 12.3173 10.3366 12.1772L10.342 12.0976V6.63415L10.3366 6.55454C10.3173 6.4144 10.248 6.28596 10.1414 6.19299C10.0348 6.10001 9.89812 6.04879 9.75667 6.04878ZM6.24447 6.04878C6.10302 6.04879 5.96635 6.10001 5.85975 6.19299C5.75314 6.28596 5.68381 6.4144 5.66457 6.55454L5.65911 6.63415V12.0976L5.66457 12.1772C5.68385 12.3173 5.7532 12.4457 5.8598 12.5386C5.9664 12.6315 6.10305 12.6827 6.24447 12.6827C6.3859 12.6827 6.52255 12.6315 6.62915 12.5386C6.73575 12.4457 6.8051 12.3173 6.82438 12.1772L6.82984 12.0976V6.63415L6.82438 6.55454C6.80514 6.4144 6.73581 6.28596 6.6292 6.19299C6.52259 6.10001 6.38593 6.04879 6.24447 6.04878ZM8.00057 1.56098C7.69007 1.56098 7.39229 1.68432 7.17274 1.90388C6.95318 2.12343 6.82984 2.42121 6.82984 2.73171H9.1713C9.1713 2.42121 9.04796 2.12343 8.8284 1.90388C8.60885 1.68432 8.31107 1.56098 8.00057 1.56098Z"
                                          fill="#929292"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                  <Field
                                    id={`faqs[${index}].question`}
                                    name={`faqs[${index}].question`}
                                    type="text"
                                    placeholder="Add a question i.e can I use a different tech stack?"
                                  />
                                  <ErrorMessage
                                    name={`faqs[${index}].question`}
                                  >
                                    {(msg) => (
                                      <div style={{ color: "red" }}>{msg}</div>
                                    )}
                                  </ErrorMessage>
                                  <Field
                                    id={`faqs[${index}].answer`}
                                    name={`faqs[${index}].answer`}
                                    type="text"
                                    placeholder="Add an answer i.e yes, you can use a different tech stack?"
                                  />
                                  <ErrorMessage name={`faqs[${index}].answer`}>
                                    {(msg) => (
                                      <div style={{ color: "red" }}>{msg}</div>
                                    )}
                                  </ErrorMessage>
                                </>
                              );
                            })}
                            <button
                              type="button"
                              onClick={() => push({ question: "", answer: "" })}
                            >
                              Add
                            </button>
                          </>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                  <div className="project-add--attachment">
                    <p>Other Attachments</p>
                    <div className="left">
                      <label htmlFor="attachments">
                        <Field
                          id="attachments"
                          name="attachments"
                          type="file"
                          multiple={true}
                          value={""}
                          accept="image/png, image/jpg, image/jpeg, application/pdf"
                          style={{ display: "none" }}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            const selectedFiles = Array.from(
                              event.currentTarget.files!
                            );
                            //error handling for when user uploads more than 5 media
                            // if (selectedFiles.length > 5) {
                            //   swal({
                            //     title: "Error!",
                            //     text: "You can only add 5 files!",
                            //     icon: "error",
                            //   });
                            //   return;
                            // }

                            const formdata = new FormData();
                            selectedFiles.forEach((file, index) => {
                              // error handling & validation for media uploads request to server
                              if (file.size > 5242880) {
                                swal({
                                  title: "Error!",
                                  text: "Invalid file size, files cannot be larger than 5MB",
                                  icon: "error",
                                });
                                return;
                              }
                              formdata.append(`files[${index}]`, file);
                            });
                            formdata.append(
                              "env",
                              `${process.env.REACT_APP_ENV}`
                            );
                            //media upload request to server
                            setMediaLoading(true);
                            axios({
                              method: "POST",
                              url:
                                process.env.REACT_APP_HOST_API + `uploads/file`,
                              data: formdata,
                            })
                              .then((res) => {
                                const fieldVal: string[] = [];
                                res?.data?.data?.forEach((d: any) => {
                                  setMediaBinary((prev?: any) => {
                                    return [...prev, d];
                                  });
                                  fieldVal.push(d.filepath);
                                  setFieldValue("attachments", fieldVal);
                                });
                              })
                              .then(() => {
                                setMediaLoading(false);
                              })
                              .catch((error) => {
                                setMediaLoading(false);
                                console.log(error);
                                swal({
                                  title: "Error!",
                                  text: "Something went wrong. Please try again later!",
                                  icon: "error",
                                });
                              });
                          }}
                        />
                        <div className="svg-text">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="32"
                              height="32"
                              rx="16"
                              fill="#FAFAFA"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.173 15.1706C9.7149 15.1706 9.34356 15.5419 9.34356 16C9.34356 16.4581 9.7149 16.8294 10.173 16.8294L15.2416 16.8294L15.2416 21.8981C15.2416 22.3562 15.613 22.7275 16.0711 22.7275C16.5291 22.7275 16.9005 22.3562 16.9005 21.8981L16.9005 16.8294L21.9692 16.8294C22.4272 16.8294 22.7986 16.4581 22.7986 16C22.7986 15.5419 22.4272 15.1706 21.9692 15.1706L16.9005 15.1706L16.9005 10.1019C16.9005 9.64383 16.5291 9.27249 16.0711 9.27249C15.613 9.27249 15.2416 9.64383 15.2416 10.1019L15.2416 15.1706L10.173 15.1706Z"
                              fill="#929292"
                            />
                          </svg>
                        </div>
                      </label>
                    </div>
                    {mediaLoading && (
                      <CircularProgress
                        sx={{ color: "gray", mt: 2 }}
                        size={12}
                      />
                    )}
                    <div
                      style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}
                    >
                      {mediaBinary?.length > 0
                        ? mediaBinary?.map((media: any, i: number) => {
                            //preview of uploaded media
                            return (
                              <div className="svg-item" key={i}>
                                <div>
                                  <span>
                                    <svg
                                      width="28"
                                      height="28"
                                      viewBox="0 0 28 28"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clipPath="url(#clip0_6886_42243)">
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M3.33301 0C2.78072 0 2.33301 0.447715 2.33301 1V27C2.33301 27.5523 2.78072 28 3.33301 28H24.6663C25.2186 28 25.6663 27.5523 25.6663 27V4.66667L20.9997 0H3.33301Z"
                                          fill="#E9F0FA"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M20.9995 0V4.66667H25.6662L20.9995 0Z"
                                          fill="#C2CDDE"
                                        />
                                      </g>
                                      <rect
                                        x="1.1665"
                                        y="11.667"
                                        width="25.6667"
                                        height="11.6667"
                                        rx="1"
                                        fill="#3E76CD"
                                      />
                                      <path
                                        d="M6.43714 20.5V14.6818H10.1644V15.5653H7.49112V17.1449H9.90874V18.0284H7.49112V20.5H6.43714ZM12.1786 14.6818V20.5H11.1246V14.6818H12.1786ZM13.32 20.5V14.6818H14.3739V19.6165H16.9364V20.5H13.32ZM17.8512 20.5V14.6818H21.6353V15.5653H18.9052V17.1449H21.4393V18.0284H18.9052V19.6165H21.658V20.5H17.8512Z"
                                        fill="white"
                                      />
                                      <defs>
                                        <clipPath id="clip0_6886_42243">
                                          <rect
                                            width="23.3333"
                                            height="28"
                                            fill="white"
                                            transform="translate(2.33301)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                </div>
                                <div className="svg-item-name">
                                  <p>
                                    {getAttachFilename(media.original_name)}
                                  </p>
                                  <p style={{ fontSize: "12px" }}>
                                    {getCurrentDate()}
                                  </p>
                                </div>

                                <button
                                  type="button"
                                  onClick={(event) => {
                                    event?.preventDefault();
                                    const uploaded: any[] = [...mediaBinary];
                                    uploaded.splice(i, 1);
                                    setMediaBinary(uploaded);
                                    // let payload = {};
                                    // if (
                                    //   typeof file === 'string'
                                    // ) {
                                    //   payload = {
                                    //     filepath: file,
                                    //   };
                                    // } else if (
                                    //   typeof file === 'object'
                                    // ) {
                                    //   payload = {
                                    //     filepath: file.filename,
                                    //   };
                                    // }
                                    // axios({
                                    //   method: 'POST',
                                    //   url:
                                    //     process.env
                                    //       .NEXT_PUBLIC_HOST_API +
                                    //     `project/delete-attachment`,
                                    //   headers: {
                                    //     Authorization: `Bearer ${isAuth()}`,
                                    //   },
                                    //   data: payload,
                                    // })
                                    //   .then((res) => {
                                    //     if (
                                    //       res.data.response ===
                                    //       true
                                    //     ) {

                                    //     }
                                    //   })
                                    //   .catch((err) => {
                                    //     console.error(err);
                                    //     swal({
                                    //       icon: 'error',
                                    //       text: 'Something went wrong. Please try again later!',
                                    //     });
                                    //   });
                                  }}
                                >
                                  <svg
                                    width="13"
                                    height="14"
                                    viewBox="0 0 13 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.16667 10.9997C5.34348 10.9997 5.51305 10.9294 5.63807 10.8044C5.7631 10.6794 5.83333 10.5098 5.83333 10.333V6.33301C5.83333 6.1562 5.7631 5.98663 5.63807 5.8616C5.51305 5.73658 5.34348 5.66634 5.16667 5.66634C4.98986 5.66634 4.82029 5.73658 4.69526 5.8616C4.57024 5.98663 4.5 6.1562 4.5 6.33301V10.333C4.5 10.5098 4.57024 10.6794 4.69526 10.8044C4.82029 10.9294 4.98986 10.9997 5.16667 10.9997ZM11.8333 2.99967H9.16667V2.33301C9.16667 1.80257 8.95595 1.29387 8.58088 0.918794C8.20581 0.543722 7.6971 0.333008 7.16667 0.333008H5.83333C5.3029 0.333008 4.79419 0.543722 4.41912 0.918794C4.04405 1.29387 3.83333 1.80257 3.83333 2.33301V2.99967H1.16667C0.989856 2.99967 0.820286 3.06991 0.695262 3.19494C0.570238 3.31996 0.5 3.48953 0.5 3.66634C0.5 3.84315 0.570238 4.01272 0.695262 4.13775C0.820286 4.26277 0.989856 4.33301 1.16667 4.33301H1.83333V11.6663C1.83333 12.1968 2.04405 12.7055 2.41912 13.0806C2.79419 13.4556 3.3029 13.6663 3.83333 13.6663H9.16667C9.6971 13.6663 10.2058 13.4556 10.5809 13.0806C10.956 12.7055 11.1667 12.1968 11.1667 11.6663V4.33301H11.8333C12.0101 4.33301 12.1797 4.26277 12.3047 4.13775C12.4298 4.01272 12.5 3.84315 12.5 3.66634C12.5 3.48953 12.4298 3.31996 12.3047 3.19494C12.1797 3.06991 12.0101 2.99967 11.8333 2.99967ZM5.16667 2.33301C5.16667 2.1562 5.2369 1.98663 5.36193 1.8616C5.48695 1.73658 5.65652 1.66634 5.83333 1.66634H7.16667C7.34348 1.66634 7.51305 1.73658 7.63807 1.8616C7.7631 1.98663 7.83333 2.1562 7.83333 2.33301V2.99967H5.16667V2.33301ZM9.83333 11.6663C9.83333 11.8432 9.7631 12.0127 9.63807 12.1377C9.51305 12.2628 9.34348 12.333 9.16667 12.333H3.83333C3.65652 12.333 3.48695 12.2628 3.36193 12.1377C3.2369 12.0127 3.16667 11.8432 3.16667 11.6663V4.33301H9.83333V11.6663ZM7.83333 10.9997C8.01014 10.9997 8.17971 10.9294 8.30474 10.8044C8.42976 10.6794 8.5 10.5098 8.5 10.333V6.33301C8.5 6.1562 8.42976 5.98663 8.30474 5.8616C8.17971 5.73658 8.01014 5.66634 7.83333 5.66634C7.65652 5.66634 7.48695 5.73658 7.36193 5.8616C7.23691 5.98663 7.16667 6.1562 7.16667 6.33301V10.333C7.16667 10.5098 7.23691 10.6794 7.36193 10.8044C7.48695 10.9294 7.65652 10.9997 7.83333 10.9997Z"
                                      fill="#F92828"
                                    />
                                  </svg>
                                </button>
                              </div>
                            );
                          })
                        : null}
                    </div>

                    <ErrorMessage name="attachments">
                      {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className="project-add--btn">
                  <button type="submit">
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </Form>
            </>
          )}
        </Formik>
      </div>
    </Fragment>
  );
};
export default AddProject;
